<template lang='pug'>
  div(:class="{both: hasLocal}")
    v-tooltip(bottom)
      template(v-slot:activator='{on}')
        v-btn.tight-button(v-on='on' :disabled='disabled' @click='run' text icon)
          v-icon play_arrow
      span Run
    v-tooltip(bottom v-if='hasLocal')
      template(v-slot:activator='{on}')
        v-btn.tight-button(v-on='on' :disabled='disabled' @click='runLocal' text icon)
          v-icon airplay
      span Run Local
</template>

<script>
import {get} from 'lodash';
import {mapGetters} from 'vuex';
import TestRun from '@/api/testRun';
import Notifications from '@/services/notification.service';

export default {
  name: 'BionicMetricsRunButtons',
  props: {
    quickRunTest: {
      type: Object
    },
    dashboardGuid: {
      type: String
    },
    testSuite: {
      type: Object,
      required: true
    },
    suiteStatus: {
      type: Object
    }
  },
  computed: {
    disabled() {
      return !!(this.savingStatus === 'SAVING' || this.debounce || (this.suiteStatus && (this.suiteStatus.isRunning || this.suiteStatus.isStarting)));
    },
    ...mapGetters({
      hasLocal: 'isLocalRunning',
      gitBranch: 'getGitBranch',
      savingStatus: 'getSavingStatus'
    })
  },
  methods: {
    async run() {
      return this.runTestSuite();
    },
    async runLocal() {
      return this.runTestSuite(true);
    },
    async runTestSuite(local) {
      try {
        this.debounce = true;
        const config = {
          testSuiteGuid: this.testSuite.guid,
          local: !!local
        };
        if (this.dashboardGuid) config.dashboardGuid = this.dashboardGuid;
        if (this.quickRunTest) {
          config.quickRunTest = this.quickRunTest;
          config.source = 'quickRun';
        }
        const newRunGuid = await TestRun.create(config);
        this.$emit('starting', {testSuiteGuid: this.testSuite.guid, runGuid: newRunGuid});
      } catch (e) {
        const message = get(e, 'response.data.message');
        if (message === 'GIT_BRANCH_DNE') {
          Notifications.alert(`Git branch <strong>${this.gitBranch}</strong> does not exist. Please create this branch in GitHub.`);
        } else {
          console.error(`Error running Test Suite: ${e.message}`);
          console.error(e);
          Notifications.errorToast('Error Running Test Suite', {
            duration: 30000,
            retry: () => this.runTestSuite(local)
          });
        }
      } finally {
        this.debounce = false;
      }
    }
  },
  data() {
    return {
      debounce: false
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.both {
  min-width: 72px;
}

.tight-button {
  margin: 0;
  padding: 0;
}
</style>
